export default __webpack_public_path__ + "static/media/WM-FL_2020_seemore01_NA-S106FX1_NZ_201014_WH_front-nz.924d1f4d.jpg";